var map = {
	"./DEM.png": "0c43",
	"./False-Colour-Optical.png": "611a",
	"./Fires-Land-Cover-Dashboard.png": "4d26",
	"./Indices-four.png": "c9ac",
	"./Optical-Timeseries.png": "aa67",
	"./Radar-Timeseries.png": "d917",
	"./S1-Ships.png": "8746",
	"./S1-Typhoon-Idai.png": "e59d",
	"./Simple-Optical.png": "82ab",
	"./Simple-Radar.png": "886a",
	"./WORKFLOW_1_1.png": "246e",
	"./WORKFLOW_1_2.png": "829e",
	"./WORKFLOW_1_3.png": "1866",
	"./WORKFLOW_1_4.png": "8f3d",
	"./WORKFLOW_1_4a.png": "3b2a",
	"./WORKFLOW_1_4b.png": "d3ce",
	"./WORKFLOW_1_5.png": "b571",
	"./WORKFLOW_1_6.png": "6662",
	"./WORKFLOW_2_1.png": "cc90",
	"./WORKFLOW_2_2.png": "6662c",
	"./WORKFLOW_2_3.png": "9854",
	"./WORKFLOW_3_1.png": "8d998",
	"./WORKFLOW_3_2.png": "fad7",
	"./WORKFLOW_3_3.png": "49ad",
	"./WORKFLOW_4_1.png": "7d91",
	"./WORKFLOW_4_2.png": "6bbb",
	"./amazon_deforestation.png": "e8a2",
	"./supervised.png": "71d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0854";